import { ModalService } from "./ModalService";
import { Toaster } from "./Toaster";

export class AppServices {
   private modal_ = new ModalService();
   private toaster_ = new Toaster();

   public get modalService(): ModalService {
      return this.modal_;
   }

   public get toastService(): Toaster {
      return this.toaster_;
   }
}